import React, { useState } from 'react';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { toast } from 'react-toastify';
import axios from 'axios';
import AssignTeachers from '../AssignTeachers';

const AddStudents = ({ isModalOpen, setIsModalOpen, closeModal }) => {
  const [planData, setPlanData] = useState({
    teacherName: '',
    fatherName: '',
    qualification: '',
    address: '',
    email: '',
    age: '',
    whatsappNo: '',
    country: '',
    status: '',
    phoneNo: '',
    password: '',
    image: null,
    timeSlots: [{ startTime: '', endTime: '' }]
  });

  const [loading, setLoader] = useState(false);
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [image, setImage] = useState('');
  const [isCheckingEnrollment, setIsCheckingEnrollment] = useState(false);
  const [isEmailRegistered, setIsEmailRegistered] = useState(false);
  const [student, setStudent] = useState({});
  const [assign, setAssign] = useState(false);
  const [studentId, setStudentId] = useState(null);
  const [isInvalidEmailCase, setIsInvalidEmailCase] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'email') {
      setIsEmailChecked(false);
      setIsEmailRegistered(false);
    }

    setPlanData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const imageUrl = URL.createObjectURL(file); // Convert File to URL
      setPlanData({ ...planData, image: imageUrl });
    }
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({ ...prev, image: null }));
  };

  const checkEnrollmentStatus = async () => {
    const email = planData.email;
    if (!email) {
      toast.error('Please enter an email address');
      return;
    }

    setIsCheckingEnrollment(true);
    setIsInvalidEmailCase(false); // Reset invalid case state

    try {
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      const raw = JSON.stringify({
        email: planData.email
      });

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch('https://quran-backend-theta.vercel.app/v1/user/user-by-email', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          let data = JSON.parse(result);
          // console.log('Check Data', data?.data);
          if (data?.status === 'new') {
            toast.success('You can proceed with a new student registration.');
            setPlanData((prev) => ({
              ...prev,
              teacherName: '',
              fatherName: '',
              qualification: '',
              address: '',
              age: '',
              whatsappNo: '',
              country: '',
              status: '',
              phoneNo: '',
              password: '',
              timeSlots: [{ startTime: '', endTime: '' }]
            }));

            setIsEmailRegistered(false);
            setStudent(data?.data);
            setStudentId(data?.data._id);

            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }

            setImage(null);
          } else if (data?.status === 'old') {
            setIsEmailRegistered(true);
            setStudent(data?.data);
            setStudentId(data?.data._id);
            setPlanData({
              teacherName: data?.data.name || '',
              fatherName: data?.data.fatherName || '',
              qualification: data?.data.qualification || '',
              address: data?.data.address || '',
              email: data?.data.email || '',
              age: data?.data.age || '',
              whatsappNo: data?.data.whatsappNumber || '',
              country: data?.data.country || '',
              status: data?.data.status || '',
              phoneNo: data?.data.phoneNumber || '',
              password: data?.data.password || '',
              image: data?.data.photo || null,
              timeSlots: data?.data.timeSlots || [{ startTime: '', endTime: '' }]
            });

            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }

            setImage(data?.data.photo || null);
          } else {
            // Handle invalid case (neither 'new' nor 'old')
            setIsInvalidEmailCase(true);
            setIsEmailRegistered(false);
            toast.error('Invalid email case.');
          }
        })
        .catch((error) => console.error(error));
    } catch (error) {
      toast.error(error?.response?.data?.error);
    } finally {
      setIsCheckingEnrollment(false);
      setIsEmailChecked(true);
    }
  };

const bannerSubmit = async (e) => {
  e.preventDefault();
  const email = planData?.email;

  if (!email) {
    toast.error('Please enter an email address');
    return;
  }

  if (!isEmailChecked) {
    toast.error('Please check the email before registering.');
    return;
  }

  if (isEmailRegistered) {
    toast.error('Email is already registered.');
    return;
  }

  setLoader(true);

  let photoUrl = '';
  if (image) {
    const formdata = new FormData();
    formdata.append('images', image);

    try {
      const uploadResponse = await fetch('https://file-upload-ashen.vercel.app/api/upload', {
        method: 'POST',
        body: formdata
      });

      const uploadResult = await uploadResponse.json();

      if (uploadResult?.success) {
        photoUrl = uploadResult.data[0]; // store image URL
      } else {
        setLoader(false);
        toast.error('Error In Uploading Image...');
        return;
      }
    } catch (error) {
      setLoader(false);
      toast.error('Image upload failed');
      return;
    }
  }

  try {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

    const raw = JSON.stringify({
      name: planData.teacherName,
      email: planData.email,
      password: planData.password,
      fatherName: planData.fatherName,
      qualification: planData.qualification,
      address: planData.address,
      age: planData.age,
      country: planData.country,
      status: planData.status,
      whatsappNumber: planData.whatsappNo,
      phoneNumber: planData.phoneNo,
      photo: photoUrl || null,  // send null if image not uploaded
      cnic: photoUrl || null,
      role: 'student',
      timeSlots: planData.timeSlots
    });

    const registerResponse = await fetch(
      'https://quran-backend-theta.vercel.app/v1/user/register',
      {
        method: 'POST',
        headers: myHeaders,
        body: raw
      }
    );

    const registerResult = await registerResponse.json();

    if (registerResult?.success === true) {
      setStudentId(registerResult.data._id);
      setLoader(false);
      setAssign(true);
      setIsModalOpen(false);
      setStudent(registerResult?.data);
      toast.success(registerResult?.data?.error);
    } else {
      setLoader(false);
      toast.error(registerResult?.error);
      setStudentId(registerResult.data._id);
    }
  } catch (error) {
    setLoader(false);
    toast.error(error?.response?.error || 'Registration failed');
  }
};


  const isFormValid = () => {
    if (isInvalidEmailCase) {
      return false; // Disable Register button in invalid case
    }

    const {
      teacherName,
      fatherName,
      qualification,
      address,
      email,
      whatsappNo,
      phoneNo,
      password,
      image,
      timeSlots
    } = planData;

    return (
      teacherName !== '' &&
      fatherName !== '' &&
      qualification !== '' &&
      address !== '' &&
      email !== '' &&
      whatsappNo !== '' &&
      phoneNo !== '' &&
      password !== ''
      // image !== null
    );
  };
  return (
    <div>
      <AssignTeachers
        getData={student}
        setIsModalOpen={setAssign}
        isModalOpen={assign}
        studentId={studentId}
      />
      <Modal isOpen={isModalOpen} onClose={closeModal} className={'rounded-md'}>
        <div className="">
          <div className="p-3 flex justify-between items-center">
            <div></div>
            <h1 className="capitalize h4 font-medium">Add Student</h1>
            <MdClose onClick={() => setIsModalOpen(false)} size={25} />
          </div>
          <hr />
          <div className="p-5">
            <form onSubmit={bannerSubmit}>
              {/* Email Section at the Top */}
              <div className="mb-5">
                <Input
                  label={'Email Address'}
                  name="email"
                  placeholder={'Email Address'}
                  className={'bg-gray-100 px-2 w-full'}
                  value={planData.email}
                  onChange={handleChange}
                />
                <Button
                  label="Check"
                  type="button"
                  className={`${isEmailChecked && !isCheckingEnrollment ? 'bg-green cursor-not-allowed' : 'bg-secondary'} mt-3 text-white py-1 w-full`}
                  onClick={checkEnrollmentStatus}
                  disabled={isEmailChecked && !isCheckingEnrollment}
                />
              </div>

              {/* Other Input Fields (Disabled until Email is Checked) */}
              <div className="flex gap-5 flex-wrap">
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Student Name'}
                    name="teacherName"
                    placeholder={'Name'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.teacherName}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Father Name'}
                    name="fatherName"
                    placeholder={'Father Name'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.fatherName}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Qualification'}
                    name="qualification"
                    placeholder={'Qualification'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.qualification}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Age'}
                    name="age"
                    placeholder={'Age'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.age}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Country'}
                    name="country"
                    placeholder={'Country'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.country}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'National ID Number'}
                    name="status"
                    placeholder={'ID Number'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.status}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Address'}
                    name="address"
                    placeholder={'Address'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.address}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'WhatsApp No'}
                    name="whatsappNo"
                    placeholder={'WhatsApp No'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.whatsappNo}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Phone No'}
                    name="phoneNo"
                    placeholder={'Phone No'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.phoneNo}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Password'}
                    name="password"
                    placeholder={'Password'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.password}
                    onChange={handleChange}
                    disabled={!isEmailChecked}
                  />
                </div>

                {/* Image upload section */}
                <div
                  className="w-full border-dashed border-[#9E9E9E] bg-[#fafafa] border-2 rounded-lg p-4 cursor-pointer"
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-14 rounded-2xl">
                    <MdOutlineFileUpload size={30} className="text-primary" />
                  </div>
                  <p className="text-primary font-medium mt-3 text-center">
                    <span className="text-secondary">Click here</span> to upload or drop CNIC
                  </p>
                  <input
                    id="fileInput"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                    disabled={!isEmailChecked}
                  />
                </div>

                {/* Image preview */}
                {planData.image && (
                  <div className="mt-4 relative">
                    {/* {console.log('Selected image:', planData.image)} */}

                    <img src={planData.image} alt="Selected" className="w-full h-auto rounded-md" />
                    <MdClose
                      onClick={handleRemoveImage}
                      className="absolute top-2 right-2 text-white cursor-pointer"
                      size={30}
                    />
                  </div>
                )}
              </div>

              {loading ? (
                <button
                  disabled
                  type="button"
                  className="bg-[#FB5722] w-full text-center mt-3 py-2.5 rounded-lg text-white uppercase font-semibold cursor-pointer"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                  Loading...
                </button>
              ) : (
                <div className="flex justify-center pt-5">
                  {isEmailRegistered ? (
                    <Button
                      label="Next"
                      type="button"
                      className="bg-secondary mt-3 text-white py-2.5 w-full"
                      onClick={() => {
                        setAssign(true);
                        setIsModalOpen(false);
                      }}
                    />
                  ) : (
                    <Button
                      label="Register"
                      type="submit"
                      className={`mt-3 py-2.5 w-full ${
                        !isFormValid() || isInvalidEmailCase
                          ? 'bg-gray-400 cursor-not-allowed'
                          : 'bg-secondary cursor-pointer'
                      } text-white uppercase font-semibold rounded-lg`}
                      disabled={!isFormValid() || isInvalidEmailCase}
                    />
                  )}
                </div>
              )}
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddStudents;
